import { get } from '@/backend/api'
import { parseError } from '@/backend/error'
import { isErrorResponse } from '@/backend/error/types'

import type { AttributePayload } from './types'
import type { ApiResult } from './types'

export const loadTeamAnnotationAttributes = async (
  teamSlug: string,
): Promise<ApiResult<AttributePayload[]>> => {
  const path = `teams/${teamSlug}/attributes`
  try {
    const response = await get<AttributePayload[]>(path)
    return { data: response.data, ok: true }
  } catch (error) {
    if (!isErrorResponse(error)) {
      throw error
    }
    return { ...parseError(error), ok: false }
  }
}
